// extracted by mini-css-extract-plugin
export default {"r_l":"_118e4fdd55 f5c13a82bf","t":"a25877691c"};